import {
  Field,
  FieldDescription,
  FieldError,
  FieldGroup,
  FieldLabel,
  FieldSet,
} from "@/components/ui/field";
import { Textarea } from "@/components/ui/textarea";
import { cn } from "@/lib/utils";
import type { ComponentProps } from "react";

interface ICustomTextAreaProps extends ComponentProps<"textarea"> {
  label?: string;
  error?: string;
  description?: string;
  labelClassName?: string;
  showCounter?: boolean;
  count?: number;
  countLimit?: number;
}

const CustomTextArea = ({
  label,
  id,
  error,
  description,
  labelClassName,
  showCounter,
  count,
  countLimit,
  ...props
}: Readonly<ICustomTextAreaProps>) => {
  return (
    <FieldSet className="w-full ">
      <FieldGroup>
        <Field className=" flex flex-col gap-1">
          <FieldLabel htmlFor={id} className={cn("text-base", labelClassName)}>
            {label}
          </FieldLabel>
          {description && <FieldDescription>{description}</FieldDescription>}
          <div className="has-[[data-slot][aria-invalid=true]]:animate-shake">
            <Textarea id={id} aria-invalid={!!error} {...props} />
          </div>
          {(error || countLimit !== undefined) && (
            <div className="flex items-start justify-between gap-2">
              {error && <FieldError className="text-xs">{error}</FieldError>}
              {countLimit !== undefined && (
                <p
                  aria-live="polite"
                  aria-hidden={!showCounter}
                  className={cn(
                    "ml-auto text-xs transition-opacity duration-200 motion-reduce:transition-none",
                    showCounter ? "opacity-100" : "opacity-0",
                  )}
                >
                  {count ?? 0}/{countLimit}
                </p>
              )}
            </div>
          )}
        </Field>
      </FieldGroup>
    </FieldSet>
  );
};

export default CustomTextArea;
